import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.INTERFACE_MANAGEMENT.VISA_BASE_II.FEES_MENU;

export const FeesMenuLinks: Array<LinkItemProps> = [
  {
    name: 'Sorties',
    link: URL.OUTGOING_MENU.ROOT,
    level: 3,
    subMenu: [
      {
        name: "Création",
        link: URL.OUTGOING_MENU.CREATION,
        level: 4,
      },
      {
        name: "Consultation",
        link: URL.OUTGOING_MENU.CONSULTATION,
        level: 4,
      },
    ]
  },
  {
    name: 'Entrées',
    link: URL.INCOMING_MENU.ROOT,
    level: 3,
    subMenu: [
      {
        name: "Consultation",
        link: URL.INCOMING_MENU.CONSULTATION,
        level: 4,
      },
    ]
  },  
];

